import classes from './styles.module.css';

type titleProps = {
    align?: string,
    lgTitleColor?: string,
    smTitleColor?: string,
    smTitle?: string,
    lgTitle: string
}

export default function Title(props: titleProps) {
    return (<div className={classes.title}>
        <div style={props.smTitleColor ? { color: props.smTitleColor } : {}}>
            {props.smTitle}
        </div>
        <h2 style={props.lgTitleColor ? { color: props.lgTitleColor } : {}}>
            {props.lgTitle}
        </h2>
    </div>
    )
}